import { CheckCircle } from "lucide-react";
import React from "react";

interface SuccessMessageProps {
  message?: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message = "Pagamento processado com sucesso!",
}) => {
  return (
    <div className="success-message p-12">
      <CheckCircle size={48} style={{ marginBottom: "20px" }} />
      <h3>Pagamento Processado com Sucesso!</h3>
      <p>{message}</p>
    </div>
  );
};

export default SuccessMessage;
